import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { firstValueFrom, map } from 'rxjs';
import { EventConfigResponseData } from 'src/app/@data-services/event-config/event-config.data-model';
import { EventConfigStateService } from 'src/app/@store/event-config-state.service';
import { LanguageStore } from 'src/app/@store/language-store';
import { applyDocumentTitle } from 'src/app/@utils/apply-document-title';
import { applyTheme } from 'src/app/@utils/apply-theme';
import { environment } from 'src/environments/environment';
import { getEuEndpointsForHostname } from './eu-event-routing.config';

export function appEventConfigInitializer() {
  const http = inject(HttpClient);

  // Apply EU endpoint overrides if the current event is hosted in EU
  const euEndpoints = getEuEndpointsForHostname(window.location.hostname);
  if (euEndpoints) {
    environment.apiUrl = euEndpoints.apiUrl;
    environment.wsUrl = euEndpoints.wsUrl;
    environment.X_API_KEY = euEndpoints.xApiKey;
  }

  const apiUrl = environment.apiUrl;
  const eventConfigStateService = inject(EventConfigStateService);
  const languageStore = inject(LanguageStore);

  return (): Promise<void> =>
    firstValueFrom(
      http
        .post<EventConfigResponseData>(apiUrl + '/r1/getEventConfig', {
          domain:
            window.location.hostname === 'localhost'
              ? environment.localhostDomain
              : window.location.hostname,
        })
        .pipe(
          map((response) => {
            eventConfigStateService.setEventIdentifier(
              response.data.EventIdentifier
            );
            eventConfigStateService.setEventConfigData(response.data);
            eventConfigStateService.setSponsors(response.data.Sponsors);
            eventConfigStateService.setFeatureConfigData(
              response.data.Features
            );
            languageStore.setAvailableLanguages(
              response.data.SupportedLanguages
            );
            languageStore.setOriginalLanguageCode(
              response.data.OriginalLanguageCode
            );
            applyTheme(response.data.Themes);
            applyDocumentTitle(response.data.Information.EventNameDisplay);
          })
        )
    );
}
